import * as React from "react";

export const Clock: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#CDD3DC",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M10 5.75V10l2.833 1.417"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M10 17.083a7.083 7.083 0 1 0 0-14.166 7.083 7.083 0 0 0 0 14.166"
    ></path>
  </svg>
);
